class SimpleToast extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #333;
          color: white;
          padding: 10px 20px;
          border-radius: 4px;
          z-index: 10001;
          opacity: 0;
          visibility: hidden;
          transition: none;
          pointer-events: none;
          width: max-content;
          max-width: 80%;
        }
        :host(.mounted) {
          transition: opacity 0.3s, visibility 0.3s;
        }
        :host(.show) {
          opacity: 1;
          visibility: visible;
        }
      </style>
      <slot></slot>
    `;

    // 避免组件首次挂载时出现 opacity 1 -> 0 的过渡闪动；
    // 等首帧渲染后再启用 transition，后续 show/hide 保持动画。
    requestAnimationFrame(() => {
      this.classList.add('mounted');
    });
  }

  show(message, duration = 4000) {
    if (message != undefined) {
      this.innerHTML = message;
    }
    this.classList.add('show');
    setTimeout(() => this.classList.remove('show'), duration);
  }
}

if (!customElements.get('simple-toast')) {
  customElements.define('simple-toast', SimpleToast);
}

export {
  SimpleToast
};